import React from 'react';
import { DatePicker } from 'antd';
import styled from 'styled-components';

import Icon from '../../icons/Icon';

import { FormFieldLabel } from './FormFieldLabel';
import { FormInputProps, StyledFormItem } from './FormInput';

const DatePickerIcon = styled(Icon).attrs({
  name: 'DatePicker',
})`
  vertical-align: -0.2rem;
`;

export const FormDatePicker: React.FC<FormInputProps> = ({ name, label, required, allowClear = true, disabled }) => {
  return (
    <StyledFormItem
      name={name}
      style={{ marginBottom: 5, width: '100%' }}
      label={<FormFieldLabel required={required}>{label}</FormFieldLabel>}
    >
      <DatePicker
        style={{ width: '100%' }}
        suffixIcon={<DatePickerIcon />}
        allowClear={allowClear}
        disabled={disabled}
      />
    </StyledFormItem>
  );
};
